import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchAuthSession } from "@aws-amplify/auth";

const API_BASE_URL = "https://api.cupvisor.org";

function HomePage() {
  const [loading, setLoading] = useState(true);
  const [roleMessage, setRoleMessage] = useState("");
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function loadRoles() {
      try {
        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        const response = await fetch(`${API_BASE_URL}/auth/groups`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          "Accept": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error(`Auth groups endpoint returned status ${response.status}`);
        }
        const data = await response.json();
        const fetchedRoles = data.roles || [];
        setRoles(fetchedRoles);
        if (fetchedRoles.length === 0) {
          setRoleMessage("No roles assigned");
        } else {
          setRoleMessage(fetchedRoles.join(", "));
          // Automatically redirect if the "User" role exists.
          if (fetchedRoles.includes("User")) {
            navigate("/users");
            return;
          }
        }
      } catch (err) {
        console.error("Error fetching roles:", err);
        setRoleMessage("Error fetching roles");
      } finally {
        setLoading(false);
      }
    }
    loadRoles();
  }, [navigate]);

  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(135deg, #ff66cc, #9933ff)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "2rem 3rem",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              margin: 0,
              color: "#9933ff",
              fontSize: "2rem",
              fontFamily: "sans-serif",
            }}
          >
            Welcome to SwapStamp!
          </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h1>Welcome to Cupvisor</h1>
      <p>
        You have the following roles: <strong>{roleMessage}</strong>
      </p>
      <div>
        {roles.includes("Admin") && (
          <p>
            Go to your <a href="/admin">Admin Portal</a>.
          </p>
        )}
        {roles.includes("Vendor") && (
          <p>
            Go to your <a href="/vendor_portal">Vendor Portal</a>.
          </p>
        )}
        {roles.length === 0 && (
          <p>Please contact support if you believe you should have a role.</p>
        )}
      </div>
    </div>
  );
}

export default HomePage;
